import React from 'react';

function ProgressCard({ sold = 0, total = 10000 }) {
    const progress = (sold / total) * 100;

    return (
        <div
            className="flex flex-col justify-between items-center w-[90px] h-[75px] md:w-[260px] md:h-150 bg-[#655884] shadow-black rounded-[12px] "
            style={{ boxShadow: '0 2px 10px rgba(0, 0, 0, 0.5)' }}
        >
            <p className="hidden md:flex text-16 flex justify-center h-[0px] md:h-[110px] items-center text-white text-xs md:text-40">
                {sold}/?????
            </p>

            <p className="block md:hidden text-16 flex flex-col h-[61px] md:h-[0px] justify-center items-center text-white text-xs md:text-40">
                <p className='h-[14px] text-16'>0</p>
                <p className='h-[14px] text-16'>out of</p>
                <p className='h-[14px] text-16'>?????</p>
            </p>

            <div className="w-full h-[14px] md:h-[40px] bg-[#151220] rounded-b-[12px] relative overflow-hidden">
                <div
                    className="h-[14px] md:h-[40px] bg-[#6F33A9] flex pr-2 rounded-bl-[12px]"
                    style={{
                        width: `${progress}%`,
                        transition: 'width 0.3s ease-in-out',
                    }}
                >
                    <p className="text-white text-8 h-[14px] md:h-[40px] md:text-20 justify-center absolute right-2 md:right-3 top-[1.3px] md:top-[6px]">
                        0 % sold
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ProgressCard;
